import React from "react";
import Image from "next/image";
import getFullWebCdnUrl, { ossFullUrl } from "@/utils/getFullWebCdnUrl";

interface EmptyContainerProps {
	title: string;
	subTitle?: string;
	style?: React.CSSProperties | undefined;
	textStyle?: React.CSSProperties | undefined;
	btnNode?: React.ReactNode;
}

export default function EmptyContainer({ title, subTitle, style, textStyle, btnNode }: EmptyContainerProps) {
	return (
		<div className="flex flex-col items-center justify-center">
			<div className="relative m-auto mt-[88px] h-[150px] w-[210px]" style={style}>
				<Image src={ossFullUrl("/nothing-baby.png")} priority alt="nfts" width={210} height={150} />
			</div>
			<div className="pt-2.5 text-base font-medium text-high dark:text-white" style={{ ...textStyle }}>
				{title}
			</div>
			<div className="pt-2.5 text-medium text-xs dark:text-white" style={{ ...textStyle }}>
				{subTitle}
			</div>
			<div className="text-center">{btnNode}</div>
		</div>
	);
}
